import { render, staticRenderFns } from "./editSinglePage.vue?vue&type=template&id=2844ad26&scoped=true&"
import script from "./editSinglePage.vue?vue&type=script&lang=ts&"
export * from "./editSinglePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2844ad26",
  null
  
)

export default component.exports